<div class="tab-content store-config-products-tab">
  <h4 class="mb-2">Products</h4>
  <p class="text-muted mb-4">
    Store-level product catalog actions. Use Product Management for day-to-day editing; use this tab for destructive bulk operations.
  </p>

  <!-- Future: bulk product actions go here -->

  <div *ngIf="countLoading" class="text-center py-4">
    <nb-spinner size="medium"></nb-spinner>
    <p class="mt-3 text-muted mb-0">Loading product count…</p>
  </div>

  <div *ngIf="!countLoading">
    <nb-alert *ngIf="countError" status="danger" class="mb-4">
      {{ countError }}
    </nb-alert>

    <nb-alert *ngIf="!countError && productCount === 0" status="info" class="mb-4">
      This store has no products.
    </nb-alert>

    <p *ngIf="!countError && productCount > 0" class="mb-4">
      This store currently has <strong>{{ productCount }}</strong> product<span *ngIf="productCount !== 1">s</span>.
    </p>

    <!-- Future: gate with *ngIf on role (e.g. admin only) -->
    <nb-card class="border-danger danger-zone-card">
      <nb-card-header class="bg-danger text-white">
        <div class="d-flex align-items-center">
          <nb-icon icon="alert-triangle-outline" class="me-2"></nb-icon>
          <h6 class="mb-0">Danger Zone</h6>
        </div>
      </nb-card-header>
      <nb-card-body>
        <div class="row align-items-center">
          <div class="col-md-8">
            <h6 class="text-danger mb-2">Delete All Products</h6>
            <p class="text-muted mb-0">
              <strong>⚠️ WARNING:</strong> This action will <strong>permanently delete</strong> all products from this store.
              Products will be completely removed from the database and <strong>cannot be recovered</strong>.
            </p>
          </div>
          <div class="col-md-4 text-end">
            <button
              type="button"
              class="btn btn-danger"
              (click)="deleteAllProducts()"
              [disabled]="!canDeleteAll">
              <nb-icon icon="trash-outline" class="me-2"></nb-icon>
              Delete All Products
            </button>
          </div>
        </div>
      </nb-card-body>
    </nb-card>
  </div>
</div>
